import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';
import ApiClient from '../../services/apiClient';
const _apiClient = new ApiClient();

export const useGetQuadAssertionDescriptorsByAuthorizedZones = (caseFileModelId: number, organizationGuids: string[] = [], enabled: boolean = true) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: [ 'get-quad-case-assertion-descriptors',  caseFileModelId, organizationGuids,],
        enabled: enabled,// && !!caseFileModelId && organizationGuids.length > 0, //prevents premature fetch
        queryFn: async () => {
            const response = await _apiClient.getQuadAssertionDescriptorsByAuthorizedZones(
                caseFileModelId.toString(),
                organizationGuids
            );

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve assertion descriptors.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload
        },
    });
};
